export default __webpack_public_path__ + "static/media/DInamicOR+Logo.7f6f10e5.svg";